import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PushNotificationService } from './push-notification.service';

export interface User {
  id: number;
  full_name: string;
  email: string;
  phone_number: string;
  profile_picture?: string;
  roles?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user: User;
  isLoggedIn = false;
  userName = '';
  userId = '';
  constructor(
    private router: Router,
    private pushService: PushNotificationService,
  ) {
    this.user = this.getUser();
  }

  getUserId(): number | null {
    return this.user?.id ?? null;
  }

  async logout() {
    try {
      const userId = Number(localStorage.getItem('userId'));
      const deviceToken = this.pushService['currentToken'];

      if (this.pushService?.pushTokenService && userId && deviceToken) {
        this.pushService.pushTokenService.deleteToken({
          user_id: userId,
          device_token: deviceToken,
        }).subscribe({
          next: () => console.log('Token deleted on backend'),
          error: (err) => console.error('Error deleting token', err),
        });
      }
    } catch (err) {
      console.error('Logout cleanup failed', err);
    }

    this.pushService.isInitialized = false;
    this.pushService.currentToken = null;
    this.pushService.clearLocalNotifications();
    sessionStorage.setItem('justLoggedOut', 'true');
    sessionStorage.setItem('forceHomeAfterLogoutLogin', 'true');
    localStorage.clear();
    this.user = null as any;
    this.userId = '';
    this.userName = '';
    this.isLoggedIn = false;

    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getToken(): any {
    return localStorage.getItem('auth_token');
  }
  getUser(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  refreshUser(): any {
    this.user = this.getUser();
    if (this.user) {
      this.userId = String(this.user.id ?? '');
      this.userName = this.user.full_name;
      this.isLoggedIn = true;
    }
    return this.user;
  }

  setUser(user: any): void {
    if (!user) {
      return;
    }
    localStorage.setItem('user', JSON.stringify(user));
    this.user = user;
    this.userId = String(user.id ?? '');
    this.userName = user.full_name;
    this.isLoggedIn = true;
  }

  patchUser(partial: Record<string, any>): void {
    const current = this.getUser() || this.user || {};
    this.setUser({ ...current, ...partial });
  }
  getRoles(): any {
    const roles = localStorage.getItem('roles');
    return roles ? JSON.parse(roles) : null;
  }
  isAdmin(): boolean {
    return !!this.getRoles()?.includes('Admin');
  }

  isAuthenticated(): boolean {
    try {
      const token = this.getToken();
      const user = this.getUser();

      const authenticated = !!(user && token);
      if (authenticated) {
        this.userId = String(user.id ?? '');
        this.userName = user.full_name;
        this.user = user;
      } else {
        this.userId = '';
        this.userName = '';
        this.user = null as any;
      }
      this.isLoggedIn = authenticated;
      return authenticated;
    } catch (error) {
      this.userId = '';
      this.userName = '';
      this.isLoggedIn = false;
      this.user = null as any;
      return false;
    }
  }
}
